import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LoaderContext, loaderDefaultSource } from '../interfaces/loader-context';

const defaultLoaderContext: LoaderContext = {
  source: loaderDefaultSource,
  showLoader: false,
};

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  loadCounter: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  showLoader: BehaviorSubject<LoaderContext> = new BehaviorSubject<LoaderContext>(defaultLoaderContext);
  loaderSource: string = loaderDefaultSource;

  incrementCounter(): void {
    const value = this.loadCounter.getValue() + 1;
    this.loadCounter.next(value);
    this.notify(value);
  }

  decrementCounter(): void {
    const value = this.loadCounter.getValue() - 1;
    this.loadCounter.next(value);
    this.notify(value);
  }

  isLoading(): Observable<LoaderContext> {
    return this.showLoader.asObservable();
  }

  setLoaderSource(source: string) {
    this.loaderSource = source;
  }

  resetLoaderSource() {
    this.loaderSource = loaderDefaultSource;
  }

  resetLoaderContext() {
    this.loadCounter.next(0);
    this.showLoader.next(defaultLoaderContext);
  }

  private notify(value: number) {
    if (this.loaderSource !== loaderDefaultSource && value > 0) {
      this.showLoader.next({
        source: loaderDefaultSource,
        showLoader: false,
      });
    }
    this.showLoader.next({
      source: this.loaderSource,
      showLoader: value > 0,
    });
  }
}
